import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

export const FUSEAU = 'Europe/Paris';

/** Retire les accents (décomposition Unicode) et traite les ligatures courantes. */
export function retirerAccents(texte: string): string {
  return texte
    .replace(/œ/g, 'oe')
    .replace(/Œ/g, 'OE')
    .replace(/æ/g, 'ae')
    .replace(/Æ/g, 'AE')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}

/** Minuscules, sans accents, espaces réduits : base de comparaison et de recherche. */
export function normaliserTexte(texte: string): string {
  return retirerAccents(texte).toLowerCase().replace(/\s+/g, ' ').trim();
}

/** Identifiant lisible : lettres, chiffres et tirets bas. */
export function enIdentifiant(texte: string): string {
  return normaliserTexte(texte)
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function enParis(date: Date | string | number): TZDate {
  return new TZDate(new Date(date), FUSEAU);
}

/** Date au format dd/MM/yyyy, fuseau Europe/Paris. */
export function formaterDate(date: Date | string | number): string {
  return format(enParis(date), 'dd/MM/yyyy');
}

/** Heure au format HHhmm, fuseau Europe/Paris. */
export function formaterHeure(date: Date | string | number): string {
  return format(enParis(date), "HH'h'mm");
}

/** Durée en minutes lisible : "45 min" ou "1 h 05". */
export function formaterDuree(minutes: number): string {
  const total = Math.max(0, Math.round(minutes));
  if (total < 60) return `${total} min`;
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${h} h ${String(m).padStart(2, '0')}`;
}
